<!--
     Copyright (c) 2022-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<clr-alert [clrAlertType]="type === ErrorMessageType.WARNING ? 'warning' : (type === ErrorMessageType.INFO ? 'info' : 'danger')"
           [clrAlertClosable]="false"
           [clrAlertClosed]="!show"
           *ngIf="errorMsg && errorMsg.length > 0">
    <div class="alert-item">
        <div class="alert-icon-wrapper">
            <cds-icon class="alert-icon"
                      shape="exclamation-circle"
                      [attr.aria-hidden]="true"></cds-icon>
        </div>
        <span class="alert-text"
              [innerHTML]="errorMsg">
        </span>
        <div *ngIf="type === ErrorMessageType.HELP_INFO && !!helpInfoBtn"
             class="alert-actions"
             (click)="showHelpInfo()"
             (keyup.enter)="showHelpInfo()">
            <a class="alert-action">
                {{ helpInfoBtn }}
            </a>
        </div>
        <div *ngIf="type === ErrorMessageType.ERROR && !!errorBtn"
             class="alert-actions">
            <button *ngIf="!!errorBtn && !errorLoading"
                    class="btn btn-danger"
                    [disabled]="errorBtnDisabled"
                    (click)="onErrorButtonClick()">
                {{ errorBtn }}
            </button>
            <div *ngIf="!!errorBtn && errorLoading"
                 class="alert-action-loading">
                <clr-spinner [clrSmall]="true"></clr-spinner>
                {{ errorLoadingMsg }}
            </div>
        </div>
    </div>
</clr-alert>
